// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"z8-z"};